import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useState, useEffect } from 'react';

/**
 * Be careful using this hook. It only works because the number of
 * breakpoints in theme is static. It will break once you change the number of
 * breakpoints. See https://reactjs.org/docs/hooks-rules.html#only-call-hooks-at-the-top-level
 */
const useBreakpointName = () => {
  const width = useWidth();
  let breakpoint = 'mobile';
  if (['sm', 'md'].indexOf(width) > -1) {
    breakpoint = 'medium';
  } else if (['lg', 'xl'].indexOf(width) > -1) {
    breakpoint = 'large';
  }
  return [breakpoint, width];
};

export const useWidth = () => {
  const {
    breakpoints: { keys, up },
  } = useTheme();
  return keys.reduce((output, key) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const matches = useMediaQuery(up(key));
    return matches ? key : output;
  }, null);
};

export const useIsBreakpoint = (state = false) => {
  const [isBreakpoint, setIsBreakpoint] = useState(false);
  const [selectedBreakpoint, setSelectedBreakpoint] = useState();
  const [breakpointName, width] = useBreakpointName();
  useEffect(() => {
    if (selectedBreakpoint === breakpointName || selectedBreakpoint === width) {
      setIsBreakpoint(true);
    } else {
      setIsBreakpoint(false);
    }
  }, [breakpointName, width, selectedBreakpoint]);
  return [isBreakpoint, setSelectedBreakpoint];
};

const useBreakpoint = () => {
  const [breakpoint, width] = useBreakpointName();
  return {
    mobile: breakpoint === 'mobile',
    medium: breakpoint === 'medium',
    large: breakpoint === 'large',
    width,
  };
};

export default useBreakpoint;
